import { Range } from 'slate'

export function isCheckboxListFeasible (editor) {
  const { selection } = editor
  if (!selection) {
    return false
  }

  const isCollapsed = Range.isCollapsed(selection)
  if (!isCollapsed) {
    return false
  }

  return true
}
